const WORDS = [
  "Películas",
  "Series",
  "Deportes en vivo",
  "4K Ultra HD",
  "Sin cortes",
  "+13,000 canales",
  "Estrenos",
  "Infantil",
];

export const EditorialMarquee = () => {
  const items = [...WORDS, ...WORDS];
  return (
    <section
      data-testid="editorial-marquee"
      className="relative py-8 lg:py-12 border-y border-bp-border overflow-hidden bg-bp-bg select-none"
    >
      <div className="marquee-mask">
        <div className="flex items-center gap-8 lg:gap-14 w-max animate-marquee-slow whitespace-nowrap">
          {items.map((w, i) => (
            <div key={`${w}-${i}`} className="flex items-center gap-8 lg:gap-14">
              <span
                className={`font-heading text-4xl sm:text-6xl lg:text-8xl font-semibold tracking-tight ${
                  i % 2 === 0 ? "text-white" : "text-outline"
                }`}
              >
                {w}
              </span>
              <span className="text-bp-primary text-3xl lg:text-5xl">✦</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
